export default __webpack_public_path__ + "static/media/StPhilomenaCathedral.b7919fc3.jpg";